import axios from 'axios';
import partition from 'lodash/partition';
import uniq from 'lodash/uniq';
import {cancelPreviousRequest} from '@/utils/axios/cancel-request';

const CheckoutApi = {
  async getCart() {
    const response = await axios.get('/checkout/multi/allocated-items/items');

    return response?.data?.data;
  },

  async updateAllocatedItems(entries = []) {
    const dto = buildUpdateAllocatedItemsDTO(entries);
    const response = await axios.put('/checkout/multi/allocated-items/update', dto);

    return response?.data;
  },

  async getTotalsWithAllocated(entries = []) {
    const config = cancelPreviousRequest('totals');

    const dto = buildTotalsWithAllocatedItemsDTO(entries);
    const response = await axios.put('/checkout/multi/allocated-items/totals/', dto, config);

    return response?.data?.data;
  },

  async getTotalsWithFreight(entries = []) {
    const dto = buildTotalsWithFreightDTO(entries);
    const response = await axios.put('/cart/allocated-items/freight', dto);

    return response?.data.data;
  },

  async getHoldOptions() {
    const response = await axios.get('/checkout/multi/cart-hold-options/');

    return response?.data?.data;
  },
};

function buildTotalsWithAllocatedItemsDTO(entries = []) {
  const [selectedItems, unselectedItems] = partition(entries, (item) => item.selected);
  const selectedAllocatedItemDto = selectedItems.map((item) =>
    buildAllocatedItemDTO(item.quantityAllocatedOrShipped, item.totalPrice.value, item.productType, item.sku)
  );

  const uniqueProductTypes = uniq(unselectedItems.map((item) => item.productType));
  const unselectedAllocatedItemsDto = uniqueProductTypes.map((productType) => buildAllocatedItemDTO(0, 0, productType));

  return [...selectedAllocatedItemDto, ...unselectedAllocatedItemsDto];

  function buildAllocatedItemDTO(quantity, totalPrice, groupingType, sku) {
    return {
      quantity,
      totalPrice,
      groupingType,
      ...(sku && {sku}),
    };
  }
}

function buildTotalsWithFreightDTO(entries = []) {
  return entries
    .filter((item) => item.selected)
    .map((item) => ({
      sku: item.sku,
      quantityAllocatedOrShipped: item.quantityAllocatedOrShipped,
      totalPrice: {value: item.totalPrice.value},
      groupingType: item.groupingType,
      warehouse: item.warehouse,
    }));
}

function buildUpdateAllocatedItemsDTO(entries = []) {
  return entries
    .filter((item) => item.selected)
    .map((item) => ({
      id: item.id,
      orderNumber: item.orderNumber,
      orderType: item.orderType,
      orderCompany: item.orderCompany,
      orderLineNumber: item.orderLineNumber,
      sku: item.sku,
      warehouse: item.warehouse,
      quantityAllocatedOrShipped: item.quantityAllocatedOrShipped,
      basePrice: {
        value: item.basePrice.value,
        formattedValue: item.basePrice.formattedValue,
      },
    }));
}

export {CheckoutApi};
